<template>
  <div class="biz-wrapper" v-if="showBizTypeWrapper">
    <div
      v-for="item in currentBizMap"
      class="item"
      :class="currentBizMap.length <= 4 ? 'large' : ''"
      :key="item.type"
      @click="item.disabled ? '' : toBizIndex(item.type)"
    >
      <img :class="!item.disabled ? 'active' : ''" :src="item.disabled ? item.disabledUrl : item.url" alt="" />
      <span :class="{ disabled: item.disabled }">{{ item.name }}</span>
    </div>
  </div>
</template>

<script>
import BizSwitch from './BizSwitch.js'
import { buriedPoint } from '../../lib/buriedPoint'
import common from '../../data/common'
import { trace } from 'app-core/lib/trace'

export default {
  computed: {
    currentBizMap() {
      return this.bizMap.filter((item) => item.visible)
    }
  },
  name: 'BizNav',
  props: {
    // 出行申请展示逻辑配置, 默认为展示, 若需要隐藏需在组件初始化前将钩子设为false
    showPlan: {
      type: Boolean,
      default: true
    }
  },

  data() {
    const OAT_BOOKING_HIDE = window.$ZConfig.getVal('OAT_BOOKING_HIDE')
    const isTravelVisible = BizSwitch.travel()
    const isFlightVisible = BizSwitch.flight() || BizSwitch.flightIntl()
    const isTrainVisible = BizSwitch.train()
    const isHotelVisible = BizSwitch.hotel()
    const isCarVisible = BizSwitch.car()
    return {
      stopMessage: null,
      showBizTypeWrapper:
        isTravelVisible || isFlightVisible || isTrainVisible || isHotelVisible || isCarVisible || !OAT_BOOKING_HIDE,
      bizMap: [
        {
          ...window.BASIC_CONF.BIZ_NAV.travel,
          name: this.$t('APP_HOME.chu-hang-shen-qing'),
          type: 'travel',
          disabled: !isTravelVisible,
          visible: isTravelVisible && this.showPlan
        },
        {
          name: this.$t('APP_HOME.ji-piao'),
          type: 'flight',
          ...window.BASIC_CONF.BIZ_NAV.flight,
          disabled: !isFlightVisible,
          visible: isFlightVisible || !OAT_BOOKING_HIDE
        },
        {
          name: this.$t('APP_HOME.huo-che'),
          type: 'train',
          icon: 'com-huoche11',
          ...window.BASIC_CONF.BIZ_NAV.train,
          disabled: !isTrainVisible,
          visible: isTrainVisible || !OAT_BOOKING_HIDE
        },
        {
          name: this.$t('APP_HOME.jiu-dian'),
          type: 'hotel',
          icon: 'com-jiudian1',
          ...window.BASIC_CONF.BIZ_NAV.hotel,
          disabled: !isHotelVisible,
          visible: isHotelVisible || !OAT_BOOKING_HIDE
        },
        {
          name: this.$t('APP_HOME.yong-che'),
          type: 'car',
          ...window.BASIC_CONF.BIZ_NAV.car,
          disabled: !isCarVisible,
          visible: isCarVisible || !OAT_BOOKING_HIDE
        }
      ]
    }
  },
  mounted() {
    trace.tag('RENDER_BIZNAV')
    this.$emit('rendered')
  },
  methods: {
    getCaption(obj) {
      var index = obj.lastIndexOf('&')
      obj = obj.substring(index + 1, obj.length)
      return obj
    },
    toPage(type) {
      if (type === 'travel') {
        if (window.$ZConfig.getVal('H5_TRAVEL_REQUEST_LINK')) {
          window.$jump.goLocPage(window.$ZConfig.getVal('H5_TRAVEL_REQUEST_LINK'), null, false)
        } else {
          window.$jump.goLocPage('/mg/control/plan/planIndex', null, false)
        }
      } else {
        window.$jump.goLocPage('/mg/' + type + '/index', null, false)
      }
    },
    async getStopMsg() {
      try {
        const res = await common.getNoticeAll()
        if (res.data) {
          if (res.data.code !== '0') {
            return
          }
          if (res.data.data) {
            this.stopMessage = res.data.data.stopMessage
          }
        }
      } catch (e) {
        console.log('加载在途公告失败')
      }
    },
    takePoint(type) {
      switch (type) {
        case 'car':
          buriedPoint('Button_Click_Car')
          break
        case 'travel':
          buriedPoint('Button_Click_Travel_Application')
          break
        case 'flight':
          buriedPoint('Button_Click_Flight')
          break
        case 'train':
          buriedPoint('Button_Click_Train')
          break
        case 'hotel':
          buriedPoint('Button_Click_Hotel')
          break
        default:
          break
      }
    },
    takeTrace(type) {
      switch (type) {
        case 'car':
          trace.tag('BIZNAV_CAR_CLICK', { data: { type: 'BIZNAV_CAR_CLICK', msg: '点击用车' } })
          break
        case 'travel':
          trace.tag('BIZNAV_TRAVEL_CLICK', { data: { type: 'BIZNAV_TRAVEL_CLICK', msg: '点击出行申请' } })
          break
        case 'flight':
          trace.tag('BIZNAV_FLIGHT_CLICK', { data: { type: 'BIZNAV_FLIGHT_CLICK', msg: '点击机票' } })
          break
        case 'train':
          trace.tag('BIZNAV_TRAIN_CLICK', { data: { type: 'BIZNAV_TRAIN_CLICK', msg: '点击火车' } })
          break
        case 'hotel':
          trace.tag('BIZNAV_HOTEL_CLICK', { data: { type: 'BIZNAV_HOTEL_CLICK', msg: '点击酒店' } })
          break
        default:
          break
      }
    },
    async toBizIndex(type) {
      setTimeout(() => {
        if (window.$flutter) {
          window.$flutter.haptic()
        }
      }, 50)
      this.validateStopMsg(type, () => {
        this.takePoint(type)
        this.takeTrace(type)
        if (type === 'car') {
          this.toCarPage()
        } else {
          this.toPage(type)
        }
      })
    },
    async validateStopMsg(type, callback) {
      if (!this.stopMessage) {
        await this.getStopMsg()
      }
      const stopMsg = this.stopMessage[type + '_stop_message']
      if (stopMsg) {
        this.$w.alert.show({
          title: '',
          content: stopMsg,
          buttonText: this.$t('APP_HOME.zhi-dao-le')
        })
        return
      }
      callback()
    },
    toCarPage() {
      common.getCarUrl().then((res) => {
        if (res.data.code !== '0') {
          this.$w.alert.show({
            title: '',
            content: res.data.msg
          })
          return
        }
        let data = res.data.data
        // 只有滴滴的时候直接跳滴滴
        if (data && data.length) {
          if (data.length == 1 && data[0].originType == 'didi') {
            let str = this.getCaption(data[0].encryptStr)
            let query = 'https://open.es.xiaojukeji.com/webapp/feESWebappLogin/index?' + str
            window.$jump.openLink(query)
            return
          }
          this.toPage('car')
        } else {
          this.$w.alert.show({
            content: this.$t('APP_HOME.bao-qian-zan-wei-she-zhi-yong-')
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.biz-wrapper {
  min-height: 108px;
  padding: 20px 8px;
  display: flex;
  align-items: center;
  background: #fff;
  box-shadow: 0px 2px 20px rgba(120, 154, 187, 0.2);
  border-radius: 8px;
  box-sizing: border-box;
  .item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
      user-select: none;
      -webkit-user-drag: none;
      width: 44px;
      transition: all 0.1s ease-in-out;
      &.disabled {
        filter: grayscale(1);
        opacity: 0.5;
      }
    }
    span {
      color: #595959;
      font-size: 12px;
      font-weight: 400;
      line-height: 17px;
      margin-top: 8px;
    }
    &:active {
      img.active {
        filter: brightness(0.98);
        transform: scale(1.03);
      }
    }
    &.large {
      img {
        width: 52px;
      }
      span {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
}
</style>
